export const Content_DE = {
  path1: {
    title: <>Überwachtes Lernen{" "}<span>supervised learning</span></>,
    lead: 'Die auszuführende Aufgabe ist bekannt und benötigt viel Zeit.',
    outcome:
      'Sind die Trainingsdaten gut, werden die Bilder wie gewünscht sortiert.',
    example: (
      <>
        Beispiel:<b>Sortieren von Äpfel- und Birnenfotos</b>
      </>
    ),
    how: 'Der Algorithmus lernt aus gekennzeichneten Daten. ',
    method: (
      <>
        Methode:<b>Klassifizierung und mathematische Regression</b>
      </>
    ),
    methodDesc:
      'Es werden die zugrunde liegenden Merkmale (Form, Farbe, Grösse, usw.) untersucht, welche die Eingabedaten mit ihren Kennzeichnungen verknüpfen.',
    usage: [
      'Anwendungen',
      'Klassifizierung von Bildern',
      'Aufdeckung von Identitätsbetrug',
      'Wettervorhersage',
    ],
  },
  path2: {
    title: <>Unüberwachtes Lernen{" "}<span>unsupervised learning</span></>,

    lead: 'Es sollen unbekannte Muster in den Daten entdeckt werden.',
    outcome:
      'Da kein gewünschtes Ergebnis vorgegeben wurde, sucht der Algorithmus anhand der Eigenschaften nach möglichen Ordnungen.',
    example: (
      <>
        Beispiel:<b>Finden von Mustern in Äpfel- und Birnenfotos</b>
      </>
    ),
    how: 'Der Algorithmus wird anhand von nicht gekennzeichneten Daten trainiert und es werden keine besonderen Hinweise gegeben.',
    method: (
      <>
        Methode:<b>Assoziation und Gruppierung</b>
      </>
    ),
    methodDesc: 'Entdeckt gemeinsame Muster innerhalb der Eingabedaten.',
    usage: [
      'Anwendungen',
      'Marketing-Targeting',
      'Visualisierung von grossen Datenmengen',
      'Empfehlungssysteme',
    ],
  },
  path3: {
    title: <>Bestärkendes Lernen{" "}<span>reinforcement learning</span></>,

    lead: 'Es gibt ein Ziel, aber es ist unklar, wie man es am besten erreicht.',
    outcome:
      'Das gewünschte Ergebnis wird nach mehreren Rückmeldungen zur Qualität der Aufgabenerfüllung erreicht.',
    example: (
      <>
        Beispiel:
        <b>Den besten Äpfel- und Birnenkorb für Kunden zusammenstellen</b>
      </>
    ),
    how: 'Der Algorithmus interagiert mit seiner Umgebung, indem er Aktionen durchführt und aus Fehlern und Erfolgen lernt. Dies geschieht ohne vorher bereitgestellte Daten.',
    method: (
      <>
        Methode:<b>Basiert auf einem Belohnungssystem</b>
      </>
    ),
    methodDesc:
      'Lernt eine Verhaltensstrategie auf der Grundlage früherer Erfahrungen und erhaltener Belohnungen.',
    usage: [
      'Anwendungen',
      'Entscheidungen in Echtzeit',
      'Lernen von Aufgaben',
      'Robotische Navigation',
    ],
  },
}
